module.exports = __webpack_public_path__ + "img/header-weddingRingsCeramic@2x.9e00638.jpg";